import { defineStore } from 'pinia'

export const ZN_SelDoc = defineStore('zn_doc_select', {
    state: () => {
        return { zn_doc_select: null }
    },
    actions: {
        get() {
            return this.zn_doc_select
        },
        set(data) {
            this.zn_doc_select = data
        }
    },
})